var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm1.3 12.3a1.22 1.22 0 0 1-.3.9 1.22 1.22 0 0 1-.9.3 1.2 1.2 0 1 1 0-2.4c.8 0 1.3.5 1.2 1.2Zm.1-4.5c-.4.4-.8.8-.8 1.2 0 .3.1.58.3.8v.1a.1.1 0 0 1-.1.1H7.4a.23.23 0 0 1-.2-.1c-.26-.3-.4-.7-.4-1.1.11-.67.47-1.28 1-1.7.53-.42.89-1.03 1-1.7 0-.5-.4-1.1-1.4-1.1-.69 0-1.37.13-2 .4h-.2V3.3c0-.1 0-.2.1-.2.76-.33 1.57-.5 2.4-.5 1.9 0 3.1 1.1 3.1 2.7a3.7 3.7 0 0 1-1.4 2.5Z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.549dfb206f19fe33815b5c73c9c2d334.svg";
export { ForwardRef as ReactComponent };